import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tasksAPI, usersAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';
import { fromHM } from '../../utils/duration';

export default function AssignTask() {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({
    title: '', description: '', assigned_to_id: '', priority: 'medium',
    expected_h: '', expected_m: '', deadline: '', hr_remarks: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    usersAPI.list({ is_active: true }).then(({ data }) => setEmployees(data));
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.assigned_to_id) { setError('Please select an employee'); return; }
    setError('');
    setLoading(true);
    try {
      const payload = {
        title: form.title,
        priority: form.priority,
        assigned_to_id: parseInt(form.assigned_to_id),
        expected_hours: fromHM(form.expected_h, form.expected_m),
        deadline: form.deadline ? new Date(form.deadline).toISOString() : null,
        description: form.description || null,
        hr_remarks: form.hr_remarks || null,
      };
      const { data } = await tasksAPI.assign(payload);
      navigate(`/hr/tasks/${data.id}`);
    } catch (err) {
      setError(parseApiError(err, 'Failed to assign task'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Assign Task to Employee</h2>
        <button className="btn btn-ghost" onClick={() => navigate(-1)}>← Back</button>
      </div>

      <div className="form-card">
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Assign To *</label>
            <select required value={form.assigned_to_id} onChange={set('assigned_to_id')}>
              <option value="">Select employee...</option>
              {employees.map((e) => (
                <option key={e.id} value={e.id}>{e.full_name} {e.department ? `(${e.department})` : ''}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Task Title *</label>
            <input required value={form.title} onChange={set('title')} />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea rows={4} value={form.description} onChange={set('description')} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Priority</label>
              <select value={form.priority} onChange={set('priority')}>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="urgent">Urgent</option>
              </select>
            </div>
            <div className="form-group">
              <label>Expected Time</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input type="number" min="0" value={form.expected_h} onChange={set('expected_h')} placeholder="Hours" aria-label="Expected hours" />
                <input type="number" min="0" max="59" value={form.expected_m} onChange={set('expected_m')} placeholder="Minutes" aria-label="Expected minutes" />
              </div>
              <small className="field-hint">e.g. 2 hours 30 minutes</small>
            </div>
          </div>
          <div className="form-group">
            <label>Deadline</label>
            <input type="datetime-local" value={form.deadline} onChange={set('deadline')} />
          </div>
          <div className="form-group">
            <label>HR Remarks / Instructions</label>
            <textarea rows={3} value={form.hr_remarks} onChange={set('hr_remarks')} placeholder="Special instructions..." />
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Assigning...' : 'Assign Task'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
